var _path, _path2, _path3, _path4, _path5, _circle, _path6, _path7, _path8, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 430,
    viewBox: "0 0 430 430",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.4092 145H121.409V370H46.4092V145Z",
    fill: "#4BB3FD"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4092 145H46.4092V370H81.4092V145Z",
    fill: "#4BB3FD"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M392.977 219.301V370H319.712V245.617C319.712 222.792 301.26 204.288 278.5 204.288C255.739 204.288 237.288 222.792 237.288 245.617V370H164.022V146.54H237.288V176.736L259.012 159.308C274.591 146.809 293.948 140 313.9 140C357.573 140 392.977 175.504 392.977 219.301Z",
    fill: "#4BB3FD"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M354.712 370V245.617C354.712 222.792 336.26 204.288 313.5 204.288C307.243 204.288 301.312 205.687 296 208.189C310.011 214.788 319.712 229.066 319.712 245.617V370H354.712Z",
    fill: "#4BB3FD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M199.022 146.54H164.022V370H199.022V146.54Z",
    fill: "#4BB3FD"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 83.5,
    cy: 70,
    r: 40,
    fill: "#4BB3FD"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M109.989 99.9728C109.495 99.9909 108.999 100 108.5 100C86.4086 100 68.5 82.0914 68.5 60C68.5 48.0678 73.7246 37.356 82.011 30.0272C60.6095 30.8104 43.5 48.4071 43.5 70C43.5 92.0914 61.4086 110 83.5 110C93.6592 110 102.934 106.213 109.989 99.9728Z",
    fill: "#4BB3FD"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4092 145H121.409V370H46.4092V145Z",
    stroke: "#121331",
    strokeWidth: 7,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M392.977 219.301V370H319.712V245.617C319.712 222.792 301.26 204.288 278.5 204.288C255.739 204.288 237.288 222.792 237.288 245.617V370H164.022V146.54H237.288V176.736L259.012 159.308C274.591 146.809 293.948 140 313.9 140C357.573 140 392.977 175.504 392.977 219.301Z",
    stroke: "#121331",
    strokeWidth: 7,
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.5,
    cy: 70,
    r: 40,
    stroke: "#121331",
    strokeWidth: 7,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.259f6ef4db6fcae69e84eccfec438a5d.svg";
export { ForwardRef as ReactComponent };